/* eslint-disable react/no-unused-prop-types */
import React, { Component } from 'react'
import PropTypes from 'prop-types'

// Child
import Discounts from '../../containers/cart-discounts'
import { DiscountRow, ShippingRow, SubtotalRow, EuropeanTaxRow, TaxRow } from './rows'

// Helpers
import { formatCurrency } from '@eig-builder/core-utils/helpers/currency-helper'

// Other
import sumBy from 'lodash/sumBy'
import isEmpty from 'lodash/isEmpty'
import isEqual from 'lodash/isEqual'
import some from 'lodash/some'
import Text from 'localize'
import './lang'
import { getCartPrices } from './pricing-model'

export default class CartSummaryComponent extends Component {
  static propTypes = {
    sdkCommunicationHelper: PropTypes.object.isRequired,

    checkoutUrlRetrieving: PropTypes.bool,

    doCheckout: PropTypes.func.isRequired,
    currency: PropTypes.object,

    shippingFirstItem: PropTypes.any,
    shippingRateType: PropTypes.any,
    shippingAdditionalItem: PropTypes.any,
    minimalAmountForFreeShipping: PropTypes.any,
    pricesInclTax: PropTypes.any,
    fromEu: PropTypes.any,
    calculateTaxOverShipping: PropTypes.bool,
    automaticTaxes: PropTypes.bool,
    currentTaxPercent: PropTypes.number,
    taxOriginal: PropTypes.any,
    cartContent: PropTypes.any,
    persistentDiscounts: PropTypes.arrayOf(PropTypes.object),
    actions: PropTypes.object
  }

  static defaultProps = {
    shippingFirstItem: 0,
    shippingAdditionalItem: 0,
    shippingRateType: 1,
    minimalAmountForFreeShipping: undefined,
    pricesInclTax: false,
    fromEu: false,
    calculateTaxOverShipping: false,
    automaticTaxes: false,
    currentTaxPercent: 0,
    taxOriginal: 0,
    cartContent: []
  }

  componentWillUnmount () {
    // When this method fires, the cart is empty. So update the published site cart label to 0
    this.props.sdkCommunicationHelper.updateCartLabelAndPrice(0, 0)
  }

  _doCheckout = () => {
    const { doCheckout = () => {}, persistentDiscounts = [] } = this.props

    doCheckout(persistentDiscounts.map(discount => discount.code))
  }

  onChange = discounts => {
    this.setState({ discounts }, () => {
      this.props.actions.setDiscounts(discounts)
    })
  }

  // shouldComponentUpdate (nextProps, nextState) {
  //   return (nextProps !== this.props || nextState.discounts === this.state.discounts)
  // }

  static getDerivedStateFromProps (nextProps, prevState) {
    const {
      cartContent,
      shippingFirstItem,
      shippingAdditionalItem,
      minimalAmountForFreeShipping,
      shippingRateType,
      pricesInclTax,
      fromEu,
      taxOriginal,
      currentTaxPercent,
      automaticTaxes,
      calculateTaxOverShipping,
      sdkCommunicationHelper = {}
    } = nextProps

    const { cartContent: prevCartContent = {} } = prevState || {}
    const { persistentDiscounts = [] } = nextProps

    const prices = getCartPrices({
      cartContent,
      shippingFirstItem,
      shippingAdditionalItem,
      shippingRateType,
      fromEu,
      currentTaxPercent,
      automaticTaxes,
      minimalAmountForFreeShipping,
      calculateTaxOverShipping,
      taxOriginal,
      pricesInclTax,
      discounts: persistentDiscounts
    })

    if (!isEmpty(cartContent) && !isEqual(prevCartContent, cartContent)) {
      const count = sumBy(cartContent, x => x.quantity)
      sdkCommunicationHelper.updateCartLabelAndPrice(count, prices.total)
    }

    return {
      ...prevState,
      productOutOfStock: some(cartContent, item => item.productInfo.showMaxStockWarning === true),
      prices,
      cartContent
    }
  }

  render () {
    const {
      checkoutUrlRetrieving,

      currency,

      calculateTaxOverShipping,
      automaticTaxes = false,
      currentTaxPercent,
      persistentDiscounts = []
    } = this.props

    const { productOutOfStock, prices } = this.state

    const shippingRow = <ShippingRow prices={prices} currency={currency} />
    const disabledButton = productOutOfStock || checkoutUrlRetrieving

    return (
      <div id='cart-summary'>
        <SubtotalRow prices={prices} currency={currency} />
        <DiscountRow prices={prices} currency={currency} />
        {calculateTaxOverShipping && (prices.shippingExcl > 0 || prices.shippingForFreeDiscount) && shippingRow}
        <TaxRow prices={prices} currency={currency} />
        {!calculateTaxOverShipping && (prices.shippingIncl > 0 || prices.shippingForFreeDiscount) && shippingRow}
        <div className='row py-2 total'>
          <div className='col-6'>
            <Text message='modules.cart.components.prices.total' />
          </div>
          <div className='col-6 price'>{formatCurrency(prices.grantTotalIncl, currency)}</div>
          <EuropeanTaxRow prices={prices} currency={currency} currentTaxPercent={currentTaxPercent} />
        </div>
        <Discounts currency={currency} onChange={this.onChange} persistentData={persistentDiscounts} />
        {automaticTaxes && (
          <div className='row no-gutters tax-message'>
            <Text message='modules.cart.components.prices.automatictaxes' />
          </div>
        )}
        <div className='row'>
          <div className='col'>
            <button
              className='cart-btn highlight-btn btn btn-success'
              disabled={disabledButton}
              style={{ opacity: disabledButton ? 0.4 : 1 }}
              tag='save-and-continue'
              onClick={this._doCheckout}
            >
              <Text message='modules.cart.components.shoppingCart.proceed' />
            </button>
          </div>
        </div>
      </div>
    )
  }
}
